import React, { Component } from 'react';
import $ from 'jquery';

class SecQuizPopup extends Component {
  //function secToday() {
  componentDidMount() {

  }
  
  render() {
    return (
      <aside className="popup" id="popup--quizPass">
        <div className="popup__wrap">
          <div className="popup__head">
            <button type="button" className="popup__close"><span className="sr-only">닫기</span></button>
          </div>
          <></>
          <i className="ico"> 🎉 </i>
          <p className="tit">정답입니다!</p>
          <p className="txt">혹시 시사용어 전문가?</p>
        </div>
      </aside>
    );
  }
}

export default SecQuizPopup;      